import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import './index.css'
import App from './App.tsx'
import './lib/monitoring' // Initialize Sentry + Google Analytics
// Theme 5 (failure resilience): global error handlers extracted to their own
// module so the "mutations always speak" rule is unit-testable. See
// src/lib/globalErrorHandlers.ts for the full rationale.
import { handleGlobalQueryError, handleGlobalMutationError } from './lib/globalErrorHandlers'
// 2026-08-03: defaultOptions extracted for the same reason as the handlers
// above — the mutation-reliability rules (retry: 0, networkMode: 'always') are
// unit-tested in src/lib/queryClientDefaults.test.ts.
import { queryClientDefaultOptions } from './lib/queryClientDefaults'
import { TOAST_MOBILE_TOP_OFFSET_PX, TOAST_TOP_OFFSET_PX } from '@/lib/toastPlacement'

// Create QueryClient with sensible defaults for production and E2E
const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleGlobalQueryError }),
  mutationCache: new MutationCache({ onError: handleGlobalMutationError }),
  defaultOptions: queryClientDefaultOptions,
})


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster position="top-right" offset={TOAST_TOP_OFFSET_PX} mobileOffset={TOAST_MOBILE_TOP_OFFSET_PX} richColors closeButton />
    </QueryClientProvider>
  </StrictMode>,
)
/* Force rebuild Sun Nov 16 12:15:00 MST 2025 - CDN cache bust */
